import { ServerRequest } from '../../../utils/apiweb';
import { REQUEST_METHOD } from '@laramie/ui';
import { APIS } from '../../../config/apis';

export const FindComercio = (id, callbackSuccessFindComercio, callbackNoSuccess, callbackError) => {
    
    const paramsUrl = `/${id}`;

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.COMERCIO,
        paramsUrl,
        null,
        callbackSuccessFindComercio,
        callbackNoSuccess,
        callbackError
    );

}

